/**
 * Team names providers send that ESPN's team lists do not produce, by identity league and
 * registry abbreviation. Hand-maintained; scripts/generate-team-identity.ts never writes here.
 */

import type { LeagueKey } from './league';

export const MANUAL_TEAM_NAMES: Partial<Record<LeagueKey, Record<string, readonly string[]>>> = {
  basketball_nba: {
    LAL: ['LA Lakers'],
    PHI: ['Sixers'],
  },
  // stats.nba.com's codes for these two; the other codes seen on its 2026 scoreboards resolve already.
  basketball_wnba: {
    GVV: ['GSV'],
    WSH: ['WAS'],
  },
  basketball_ncaab: {
    LIN: ['Lindenwood Lions'],
    QUC: ['Queens University Royals'],
    SEA: ['Seattle Redhawks'],
    SFPA: ['Saint Francis Red Wolves', 'Saint Francis Red Flash'],
    STMN: ['St. Thomas (MN) Tommies', 'St. Thomas-Minnesota Tommies'],
    UNO: ['New Orleans Privateers'],
    USI: ['Southern Indiana Screaming Eagles'],
  },
  basketball_wncaab: {
    CARK: ['Central Arkansas Sugar Bears'],
    HAW: ["Hawai'i Rainbow Wahine"],
    MERC: ['Mercyhurst Lakers'],
    MOST: ['Missouri State Bears'],
    SEA: ['Seattle Redhawks'],
    SFPA: ['Saint Francis Red Wolves', 'Saint Francis Red Flash'],
    STMN: ['St. Thomas (MN) Tommies', 'St. Thomas-Minnesota Tommies'],
    UNO: ['New Orleans Privateers'],
  },
};
